import React, { useEffect, useState } from 'react';
import SubscriberAdminButton from './SubscriberAdminButton';
import { useSelector } from 'react-redux';
import { getUserState } from '../../features/user/selectors';
import HelpButton from './HelpButton';
import { Tooltip } from '@material-ui/core';
import SiteAdminButton from './SiteAdminButton';
import Badge from '@material-ui/core/Badge';
import NotificationsIcon from '@material-ui/icons/Notifications';
import IconButton from '@material-ui/core/IconButton';
import { useHistory } from 'react-router-dom';
import { getProjectState } from '../../features/project/selectors';
import { getMyNotificationsWithEmailsCount } from '../../models/api/email';
import { makeStyles } from '@material-ui/core/styles';
import SearchButton from './SearchButton';
import { hasSearchPermissions } from '../../scripts/store-utils';
import FindInPageButton from './FindInPageButton';
import getProjectsState from '../../features/projects/selectors';

interface Props {
  isBiddingPortal: boolean;
}

const useStyles = makeStyles(() => ({
  customBadge: {
    backgroundColor: '#CC0000',
    color: 'white',
  },
}));

export default function NavIconbuttons(props: Props) {
  const classes = useStyles();
  const { isBiddingPortal } = props;

  const user = useSelector(getUserState);
  const projects = useSelector(getProjectsState);
  const project = useSelector(getProjectState);
  const history = useHistory();

  const [total, setTotal] = useState<number>();

  useEffect(() => {
    getMyNotificationsWithEmailsCount({ isUnread: true }).then((res) => setTotal(res));
  }, []);

  return (
    <div style={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 8 }}>
      {!window.location.pathname.endsWith('search') &&
      hasSearchPermissions(projects, project?.id) ? (
        <Tooltip title="Search" arrow placement="bottom">
          <span>
            <SearchButton />
          </span>
        </Tooltip>
      ) : null}

      <Tooltip title="Contact Us" arrow placement="bottom">
        <span>
          <HelpButton />
        </span>
      </Tooltip>

      {!!user.adminOfSubscriberId && (
        <Tooltip title="Subscriber Admin Management" arrow placement="bottom">
          <span>
            <SubscriberAdminButton />
          </span>
        </Tooltip>
      )}

      {user.isSiteAdmin && (
        <Tooltip title="Site Admin Management" arrow placement="bottom">
          <span>
            <SiteAdminButton />
          </span>
        </Tooltip>
      )}

      {!isBiddingPortal ? (
        <IconButton
          aria-label="notifications"
          style={{ marginRight: '10px', paddingLeft: 0 }}
          onClick={() =>
            history.push(`/main/${project ? `projects/${project.id}/` : ''}my-notifications`)
          }
        >
          <Badge badgeContent={total} max={999} classes={{ badge: classes.customBadge }}>
            <NotificationsIcon style={{ height: '21px', color: '#7A797A' }} />
          </Badge>
        </IconButton>
      ) : null}
    </div>
  );
}
